'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.useDI = void 0;
var react_1 = require('react');
var context_1 = require('../context');
function useDI() {
    var diContext = (0, react_1.useContext)(context_1.DIContext);
    if (!diContext) {
        throw new Error('DIContext required');
    }
    return diContext;
}
exports.useDI = useDI;
